import { Navigate } from "react-router";
import ChangePassword from "../pages/auth/changePassword";
import EmailVerify from "../pages/auth/emailVerify";
import ForgotPassword from "../pages/auth/forgot";
import Login from "../pages/auth/login";
import InquiryForm from "../pages/Enquiries/inquiryForm";
import SettingPassword from "../pages/auth/settingPassword";


export const publicRoutes = [
    {
      path: "/",
      element:<Login /> 
    },
    {
      path: "/forgot",
      element: <ForgotPassword />
    },
    {
      path: "/emailVerify",
      element: <EmailVerify  />
    },
    {
      path: "/changePassword",
      element: <ChangePassword  />
    },
    {
      path: "/resetPassword/:token",
      element: <SettingPassword  />
    },
    {
      path: "/enquiry-form",
       element: <InquiryForm />
    },
    {
      path:"*",
      element: <Navigate to="/" replace />
    }
  ];